<template>
  <div class="section" style="min-width: 1200px;">
    <div class="form-card-wrapper">
      <div class="section form-row">
        <span class="title">{{ $t('SeaExport.Warehouse2') }}</span>
        <div class="warehouse-wrap">
          <el-form :disabled="readonly" :label-width="isZh ? '100px' : '234px'" :label-position="isEn ? 'right' : 'left'">
            <el-form-item :label="$t('SeaExport.LoadingCharge2')" class="custom">
              <el-input-number v-model="packingChargeAmount" no="1" :disabled="!chargeEnable" :precision="2" :min="0" :max="999999999999" controls-position="right" @change="dealPackingCharge" />
              <span>{{ localCurrency }}</span>
              <template v-if="isZh">
                <label style="margin: 0 10px">{{ $t('SeaExport.RmbNumberOfDamagedAndDamp') }}</label>
                <el-input-number v-model="warehouseInfo.quantity" no="2" :precision="0" :min="0" :max="999999999999" controls-position="right" />
              </template>
            </el-form-item>
            <el-form-item v-if="!isZh" :label="$t('SeaExport.RmbNumberOfDamagedAndDamp2')" class="custom">
              <el-input-number v-model="warehouseInfo.quantity" no="3" :precision="0" :min="0" :max="999999999999" controls-position="right" />
            </el-form-item>

            <el-form-item :label="warehouseCmpLabel" class="auto-width">
              <cargo-company-select
                no="4"
                :method-params="{warehouse:true,active:true}"
                :default-value="warehouseInfo.warehouseCmp||''"
                style="width: 400px"
                @change="p=>{warehouseInfo.warehouseCmp=p.value||0;warehouseChangeHandler(p.value||0)}"
              />
            </el-form-item>

            <el-form-item v-if="openWarehouse" :label="$t('SeaExport.WareHouseName')" class="custom">
              <el-select
                v-model="warehouseInfo.warehouseName"
                no="5"
                :allow-create="true"
                filterable
                style="width:400px;"
                @change="nameChangeHandler"
              >
                <el-option
                  v-for="(item,index) in warehouseNameList"
                  :key="index"
                  :label="item.warehouseName"
                  :value="item.warehouseName"
                />
              </el-select>
            </el-form-item>

            <el-form-item :label="$t('SeaExport.Tel')">
              <el-input v-model="warehouseInfo.warehouseContactTel" no="6" />
            </el-form-item>

            <el-form-item :label="$t('SeaExport.Fax') " class="label-none custom">
              <el-input v-model="warehouseInfo.warehouseContactFax" no="7" />
            </el-form-item>

            <el-form-item :label="$t('SeaExport.WarehouseAddress')" class="custom">
              <el-input v-model="warehouseInfo.warehouseAddress" no="8" type="textarea" :rows="5" :filter-chars="false" style="width:400px" />
            </el-form-item>
          </el-form>

          <el-form :disabled="readonly" :style="isZh?'margin-left:100px':''" :label-width="isZh ? '100px' : '226px'" :label-position="isZh ? 'left' : 'right'">
            <el-form-item :label="$t('SeaExport.ContactWay')">
              <el-input v-if="openWarehouse" v-model="warehouseInfo.warehouseContact" no="9" style="width:400px" />
              <el-select
                v-if="!openWarehouse"
                v-model="warehouseInfo.warehouseContact"
                no="10"
                :placeholder="readonly ? '' : $t('CargoMsg.Cargo_PleaseSelect')"
                :allow-create="true"
                filterable
                style="width:400px"
                @change="contactsChangeHandler"
                @blur="selectContactBlur"
              >
                <el-option
                  v-for="(item,index) in contactList"
                  :key="index"
                  :label="item.contactPerson"
                  :value="item.contactPerson"
                />
              </el-select>
            </el-form-item>

            <el-form-item :label="$t('SeaExport.EstimatedDateOfArrivalTheWarehouse')" class="custom">
              <el-date-picker v-model="warehouseInfo.arriveDate" no="11" :disabled="readonly" type="datetime" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm:ss" :placeholder="$t('queryJob.SelectDateAndTime')" style="width:400px" />
              <!--                <el-date-picker v-model="warehouseInfo.arriveDate" type="date" style="width:130px" value-format="yyyy-MM-dd" />-->
              <!--                <el-input-number v-model="warehouseInfo.arriveDateHour" :min="0" :max="23" controls-position="right" style="width:80px" />-->
              <!--                <el-input-number v-model="warehouseInfo.arriveDateMinutes" :min="0" :max="59" controls-position="right" style="width:80px" />-->
            </el-form-item>

            <el-form-item :label="$t('SeaExport.EstimatedDateOfPickingUpTheContainer')" class="custom">
              <el-date-picker v-model="job.esd" no="12" :disabled="readonly" type="date" style="width:130px" value-format="yyyy-MM-dd" />
              <template v-if="isZh">
                <span style="margin: 0 10px;">{{ $t('SeaExport.DateOfReturningTheContainer') }}</span>
                <el-date-picker v-model="job.returnDate" no="13" :disabled="readonly" type="date" style="width:130px" value-format="yyyy-MM-dd" />
                <el-checkbox v-model="job.quarantine" no="14" :disabled="readonly" style="margin: 0 0 0 10px;">{{ $t('SeaExport.SanitaryAndPhytosanitaryStandard') }}</el-checkbox>
              </template>
            </el-form-item>

            <el-form-item v-if="!isZh" :label="$t('SeaExport.DateOfReturningTheContainer')" class="custom">
              <el-date-picker v-model="job.returnDate" no="13" :disabled="readonly" type="date" style="width:130px" value-format="yyyy-MM-dd" />
              <el-checkbox v-model="job.quarantine" no="14" :disabled="readonly" style="margin: 0 0 0 10px;">{{ $t('SeaExport.SanitaryAndPhytosanitaryStandard') }}</el-checkbox>
            </el-form-item>

            <el-form-item :label="$t('SeaExport.CargosExpectedArrivalDate')">
              <el-date-picker
                v-model="warehouseInfo.arriveDate"
                no="15"
                type="datetime"
                style="width:400px"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
              />
            </el-form-item>

            <el-form-item :label="$t('SeaExport.LoadingRemarks')" class="custom">
              <el-input v-model="warehouseInfo.remarks" no="16" type="textarea" :rows="5" :filter-chars="false" style="width:400px" />
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { cacheName, cache } from '@/utils/cacheManager'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getWarehouseDetail } from '@/api/company'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { getObjectByCache } from '@/utils/basicDataCache'
import { Company } from '@/class/model/mdm/Company'
import StrUtils from '@/utils/StrUtils'
import { Charge } from '@/class/model/act/Charge'
import ChargeUtils from '@/class/cargo/model/utils/ChargeUtils'
import { DateAutoInitRuleManage } from '@/class/cargo/model/utils/DateAutoInitRuleManage'
import { SeaImportJob } from '@/class/model/booking/SeaImportJob'
import { Job } from '@/class/model/booking/Job'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import CargoDateTimeFieldInput from '@/components/Cargo/Common/cargoDateTimeFieldInput'
import { WarehouseInfo } from '@/class/model/booking/WarehouseInfo'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import { ChargeItem } from '@/class/model/mdm/chargeItem'

export default {
  name: 'TabWarehouse',
  components: { CargoDateTimeFieldInput, cargoAdvanceSelect, cargoCompanySelect },
  props: {
    context: {
      type: Object,
      required: true
    },
    action: {
      type: String,
      required: true
    },
    cooperateEdit: { // 能否修改
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      isZh: this.$store.getters.language === 'zh',
      isEn: this.$store.getters.language === 'en',
      selectTypeNames: TYPE_NAMES,
      openWarehouse: false,
      packingChargeLocked: false,
      chargeEnable: true, // 装箱费是否允许编辑
      packingChargeAmount: 0,
      warehouseInfo: new WarehouseInfo().fillDefaultValue().getData(),
      contactList: [],
      warehouseNameList: [],
      packingCharge: {},
      currentUser: {},
      job: {}
    }
  },
  computed: {
    readonly() {
      if (!this.cooperateEdit) return true
      return this.action === 'look' // todo && this.job.printHblZbLock 暂无此属性
    },
    isEdit() {
      if (!this.cooperateEdit) return false
      return this.action !== 'look' // todo  && !this.job.printHblZbLock 暂无此属性
    },
    warehouseCmpLabel() {
      return this.openWarehouse ? this.$t('SeaExport.WarehouseSupplier') : this.$t('SeaExport.Warehouse')
    },
    localCurrency() {
      return RateUtil.localCurrencyByOffice()
    }
  },
  methods: {
    async onShow(row, isRefresh) {
      if (isRefresh) {
        this.contactList = []
        await cache.load(cacheName.USER, cacheName.CONFIG)
        this.currentUser = cache.user
        this.job = row
        this.openWarehouse = parseInt(cache.config.get('isOpenWarehouse')) > 0
        this.autoCalculateDateRule()
        await this.startLoadRelations(row)
      }
    },
    async startLoadRelations(row) {
      // 加载数据
      if (row.lob === 'SI') {
        row = new SeaImportJob(row)
      } else {
        row = new Job(row)
      }
      await Promise.all([
        row.getWarehouseInfo(),
        row.getCharges()
      ])
      this.loadResultHandler()
    },
    getSubmitData() {
      this.fillModel()
      const job = { ...this.job }
      return {
        job,
        charges: this.job.charges.filter(p => p.isDirty === true), // todo 在 费用tab 未打开的情况下 需要保持charges
        warehouseInfo: this.warehouseInfo
      }
    },
    fillModel() {

    },
    // todo cargo 未找到对应的处理调用代码
    async dealPackingCharge() {
      this.packingCharge = await this.getCost()
      let charge = this.packingCharge
      if (!this.packingChargeAmount) {
        this.packingChargeAmount = 0
      }
      const amount = this.packingChargeAmount
      // PACKING_FEE_CODE
      const chargeItemId = parseInt(cache.config.get('WarehousePackingFeeCode'))
      const chargeItem = ChargeItem.getChargeItemById(chargeItemId)
      if (chargeItem && chargeItem.active && !charge && amount > 0) {
        charge = this.createNewCharge()
        charge.chargeItemId = chargeItemId
        if (chargeItem.taxRate > 0) {
          charge.taxRate = chargeItem.taxRate
        }
        if (chargeItem.measure !== null && chargeItem.measure !== '') {
          charge.measure = chargeItem.measure
        }
        charge.unitPriceIncludeTax = parseInt(cache.config.get('InputIncludingTaxUnitPrice')) === 2
        // 其他tab 有charge 提交 需合并或其他方案待处理
        if (!this.job.charges) {
          this.job.charges = []
        }

        charge.serialNumber = this.job.charges.filter(p => !p.receivable).length + 1
        charge.isDirty = true
        this.job.charges.push(charge)
      }
      if (charge && charge.verifiedAmount === 0 && StrUtils.isEmpty(charge.billingUuid) && StrUtils.isEmpty(charge.billingPaymentUuid) && StrUtils.isEmpty(charge.invoiceUuid)) {
        if (amount !== 0 && !isNaN(amount) && this.warehouseInfo.warehouseCmp > 0) {
          charge.accountId = this.warehouseInfo.warehouseCmp
          charge.unitRate = amount
          if (charge.unitPriceIncludeTax) {
            ChargeUtils.calculateTaxAmount(charge, parseFloat((charge.unitRate * charge.quantity).toFixed(2)), charge.taxRate)
          } else {
            ChargeUtils.calculateTax(charge, parseFloat((charge.unitRate * charge.quantity).toFixed(2)), charge.taxRate, true)
          }
          charge.isDirty = true
        }
      }
      // 设置开票抬头
      if (charge && charge.accountId && charge.accountId > 0) {
        await ChargeUtils.updateDefaultInvoiceTitle([charge])
      }
    },
    createNewCharge() {
      const charge = new Charge().fillDefaultValue().getData()
      charge.jobUuid = this.job.uuid
      charge.businessDate = this.job.businessDate
      charge.quantity = 1
      charge.localCurrency = this.localCurrency
      charge.currency = this.localCurrency
      charge.exchangeRate = 1
      charge.measure = 'NML'
      charge.receivable = false
      charge.oversea = false
      charge.verifiedAmount = 0
      charge.inputDate = new Date()
      charge.inputBy = this.currentUser.userId
      charge.branchId = this.$store.getters.currentOfficeId

      charge.inputByDep = this.job.opDepartment
      charge.businessDate = this.job.businessDate

      // 此处增加标识，费用页签再保存会导致费用重复生成
      charge.createdByOther = true
      return charge
    },
    /**
     * load success
     */
    loadResultHandler() {
      // 加载不需要清空 vue 数据的双向绑定
      // this.isNullData()
      this.loadDone()
    },
    async loadDone() {
      if (this.job.warehouseInfo.length > 0) {
        this.warehouseInfo = this.job.warehouseInfo[0]
      } else {
        this.warehouseInfo = new WarehouseInfo().fillDefaultValue().getData()
        this.warehouseInfo.warehouseCmp = this.job.warehouseCmp
        this.warehouseChangeHandler(this.warehouseInfo.warehouseCmp)

        this.job.warehouseInfo = []
        this.job.warehouseInfo.push(this.warehouseInfo)
      }

      // 加载 仓库，联系人
      this.loadCompanyContacts()

      this.packingChargeLocked = false
      this.packingCharge = await this.getCost()
      this.packingChargeAmount = 0
      if (this.packingCharge) {
        if (this.packingCharge.paidOff ||
          !isNaN(this.packingCharge.verifiedAmount) && this.packingCharge.verifiedAmount !== 0 ||
          !StrUtils.isEmpty(this.packingCharge.invoiceUuid) ||
          !StrUtils.isEmpty(this.packingCharge.billingPaymentUuid)) {
          this.packingChargeLocked = true
        }
        this.packingChargeAmount = this.packingCharge.amount
      }
      // 赋值 装箱费是否可编辑
      if (!this.readonly) {
        this.chargeEnable = !this.packingChargeLocked
      } else {
        this.chargeEnable = !this.readonly
      }
    },
    getCost() {
      // PACKING_FEE_CODE  默认装箱费
      const chargeCode = parseInt(cache.config.get('WarehousePackingFeeCode'))
      let c = null
      if (!this.job.charges) return c
      for (const charge of this.job.charges) {
        if (charge.chargeItemId === chargeCode && !charge.receivable) {
          c = charge
          return c
        }
      }
      return c
    },
    /**
     * load company contact
     */
    async loadCompanyContacts() {
      // 同步 实现 loadWarehouseDetailHandler
      if (!this.warehouseInfo || this.warehouseInfo.warehouseCmp <= 0) return
      const companyCache = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', Number(this.warehouseInfo.warehouseCmp))
      if (!companyCache) {
        this.warehouseInfo.warehouseCmp = 0
        this.isNullData()
        return
      }

      const company = new Company({ cmpIdx: this.warehouseInfo.warehouseCmp })
      // 获取公司下的仓库List & 默认仓库
      const warehouseDefault = await this.getDefaultWarehouse(companyCache)
      if (this.warehouseNameList !== null) {
        // 编辑
        if (!StrUtils.isEmpty(this.warehouseInfo.uuid)) {
          const b = this.checkContactList(warehouseDefault)
          if ((!this.openWarehouse) || b) {
            this.contactList = await company.getContactsBycmpIdx()
            this.contactsOldData(this.warehouseInfo, null)
          } else {
            if (!b) {
              this.contactsOldData(null, warehouseDefault)
            }
            this.contactsOldData(this.warehouseInfo, null)
          }
        } else {
          // 新增赋值默认仓库联系人信息
          if (warehouseDefault) {
            this.warehouseInfo.warehouseContactTel = warehouseDefault.warehouseContactTel
            this.warehouseInfo.warehouseContact = warehouseDefault.warehouseContact
            this.warehouseInfo.warehouseAddress = warehouseDefault.warehouseAddress
            this.warehouseInfo.mapFile = warehouseDefault.mapFile
            this.warehouseInfo.warehouseName = warehouseDefault.warehouseName
            this.job.warehouseName = warehouseDefault.warehouseName
            if (!this.openWarehouse) {
              this.contactsOldData(null, warehouseDefault)
            }
          }
        }
      } else {
        this.isNullData()
      }

      if (StrUtils.isEmpty(this.warehouseInfo.uuid)) {
        this.getAddressText(companyCache, this.warehouseNameList)
      }
    },
    /**
     * 旧的联系人控件添加数据
     * @param company
     * @param warehouseDetail
     */
    getAddressText(company, warehouseDetail) {
      if (warehouseDetail === null || warehouseDetail.length === 0) {
        this.warehouseInfo.warehouseAddress = company.address
      }
      if (warehouseDetail != null) {
        if (warehouseDetail.length === 1) {
          var warehouse = warehouseDetail[0]
          if (StrUtils.isEmpty(warehouse.warehouseContactTel) &&
            StrUtils.isEmpty(warehouse.warehouseContact) &&
            StrUtils.isEmpty(warehouse.warehouseAddress)) {
            this.warehouseInfo.warehouseAddress = company.address
          }
        }
      }
    },

    /**
     * 旧的联系人控件添加数据
     * @param wi
     * @param w
     */
    contactsOldData(wi, w) {
      if (wi || w) {
        const list = this.contactList
        var c = {
          telephone: '',
          contactPerson: ''
        }
        if (wi) {
          c.telephone = wi.warehouseContactTel == null ? '' : wi.warehouseContactTel
          c.contactPerson = wi.warehouseContact == null ? '' : wi.warehouseContact
        }
        if (w) {
          c.telephone = w.warehouseContactTel == null ? '' : w.warehouseContactTel
          c.contactPerson = w.warehouseContact == null ? '' : w.warehouseContact
        }
        let add = true
        for (const ct of list) {
          if (ct.contactPerson === c.contactPerson && ct.telephone === c.telephone) {
            add = false
            break
          }
        }
        if (add) {
          list.push(c)
        }
        this.contactList = list

        // 双向绑定 vue 不需要
      /*  this.warehouseInfo.warehouseContact = (wi == null) ? w.warehouseContact : wi.warehouseContact
        this.warehouseInfo.warehouseContactTel = (wi == null) ? w.warehouseContactTel : wi.warehouseContactTel*/
      }
    },
    /**
     * 验证下拉框中使用仓库值还是合作伙伴值
     */
    checkContactList(defaultWarehouse) {
      // 名称非仓库 且非合作伙伴 ，默认用仓库
      let add = true
      if (defaultWarehouse && (defaultWarehouse.warehouseContactTel !== '' || defaultWarehouse.warehouseContact !== '')) {
        add = false
      }
      return add
    },
    // 加载仓库信息
    loadJobWarehouseCmp() {

    },
    isNullData() {
      this.warehouseNameList = []
      this.contactList = []
      this.warehouseInfo.warehouseContactTel = ''
      this.warehouseInfo.warehouseContact = ''
      this.warehouseInfo.warehouseAddress = ''
      this.warehouseInfo.warehouseName = ''
    },
    /**
     * 自动计算日期
     */
    async autoCalculateDateRule() {
      await DateAutoInitRuleManage.getInstance().autoCalculateDateRule(this.job, this.warehouseInfo, 'SI')
    },

    async getDefaultWarehouse(companyCache) {
      // 获取公司下的仓库List
      const companyUuid = companyCache.uuid
      this.warehouseNameList = []
      await getWarehouseDetail(companyUuid).then(async res => {
        if (res.data.length > 0) {
          this.warehouseNameList = res.data
        }
      })
      // 获取 公司下的默认仓库
      let warehouseDefault = null
      for (const warehouse of this.warehouseNameList) {
        if (warehouse.defaultWarehouse) {
          warehouseDefault = warehouse
          break
        }
      }
      if (warehouseDefault === null) {
        if (this.warehouseNameList !== null && this.warehouseNameList.length > 0) {
          warehouseDefault = this.warehouseNameList[0]
        }
      }
      return warehouseDefault
    },
    warehouseChangeHandler(warehouseCmp) {
      this.job.warehouseCmp = warehouseCmp

      this.isNullData()
      this.loadChargeHandler()
      this.dealPackingCharge()
    },

    // 仓库更改-联动
    async loadChargeHandler() {
      if (this.warehouseInfo.warehouseCmp === 0 || !this.warehouseInfo.warehouseCmp) {
        return
      }
      const companyCache = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', Number(this.warehouseInfo.warehouseCmp))
      if (companyCache == null) {
        return
      }

      // 获取公司下的仓库List & 默认仓库
      const warehouse = await this.getDefaultWarehouse(companyCache)
      if (warehouse != null) {
        this.warehouseInfo.warehouseContactTel = warehouse.warehouseContactTel
        this.warehouseInfo.warehouseContact = warehouse.warehouseContact
        this.warehouseInfo.warehouseAddress = warehouse.warehouseAddress
        this.warehouseInfo.warehouseName = warehouse.warehouseName
        if (warehouse.remarks) { this.warehouseInfo.remarks = warehouse.remarks }
        this.job.warehouseName = warehouse.warehouseName

        this.contactsOldData(null, warehouse)
        // 从cargo 操作上看 此此处未使用 公司下的联系人
        if (!this.openWarehouse) {
          this.loadContactsFunc()
        }
      } else {
        this.loadContactsFunc()
      }

      this.getAddressText(companyCache, this.warehouseNameList)
    },
    async loadContactsFunc() {
      // 实现 loadContactsFunc
      const company = new Company({ cmpIdx: this.warehouseInfo.warehouseCmp })
      this.contactList = await company.getContactsBycmpIdx()
      if (this.contactList && this.contactList.length > 0) {
        for (const ct of this.contactList) {
          if (ct.defaultContact) {
            this.warehouseInfo.warehouseContact = ct.contactPerson
            this.warehouseInfo.warehouseContactTel = ct.telephone
            break
          }
        }
      } else {
        this.warehouseInfo.warehouseContact = ''
        this.warehouseInfo.warehouseContactTel = ''
      }
    },
    /**
     * 仓库名称change
     * @param warehouseName
     */
    nameChangeHandler(warehouseName) {
      this.job.warehouseName = warehouseName
      const w = this.warehouseNameList.find(item => item.warehouseName === warehouseName)
      if (w != null) {
        this.warehouseInfo.warehouseContactTel = w.warehouseContactTel
        this.warehouseInfo.warehouseContact = w.warehouseContact
        this.warehouseInfo.warehouseAddress = w.warehouseAddress
        this.warehouseInfo.mapFile = w.mapFile
      }
    },
    /**
     * 联系人下拉框change
     * @param warehouseContact
     */
    contactsChangeHandler(contactPerson) {
      const w = this.contactList.find(item => item.contactPerson === contactPerson)
      if (w != null) {
        this.warehouseInfo.warehouseContactTel = w.telephone
      }
    },
    selectContactBlur(event) {
      this.warehouseInfo.warehouseContact = event.target.value
    }
  }
}
</script>

<style lang="scss" scoped>
.warehouse-wrap{
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  padding: 10px 0 20px 10px;
  .el-form{
    label{
      font-weight: normal;
    }
    .auto-width{
      .el-form-item__content{
        & > span{
          margin-left: 0;
          display: inline-block;
        }
      }
    }
    .el-form-item__content{
      & > span{
        margin-left: 5px;
      }
      & > label{
        margin-right: 10px;
        margin-left: 25px;
      }
    }
  }
}
</style>

<!-- 中文样式 -->
<style scoped lang="scss">
#app.zh {
  .warehouse-wrap {
    .el-form {
      width: 500px;
    }
  }
}
</style>

<!-- 英文样式 -->
<style scoped lang="scss">
#app.en {
  .warehouse-wrap {
    .el-form {
      width: auto;
    }
  }
}
</style>
